import { Injectable } from '@angular/core';
import { State, Action, Selector, StateContext } from '@ngxs/store';
import { catchError, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { NotificationService } from '../../../../../common/services/notification/notification.service';
import { TransportManagementProfileReport } from '../../../../models/profile-report';
import { TransportManagementReportService } from './transport-management-report.service';
import {
  TransportManagementReportInitialState,
  TransportManagementReportLoad,
} from './transport-management-report.actions';
import { Error, CustomHttpErrorResponse } from '../../../../../common/constants/error';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export interface TransportManagementReportStateModel {
  report: TransportManagementProfileReport;
  loaded: boolean;
}

const initialState: TransportManagementReportStateModel = {
  report: new TransportManagementProfileReport(),
  loaded: false,
};

@State<TransportManagementReportStateModel>({
  name: 'transportManagementReport',
  defaults: initialState,
})
@Injectable()
export class TransportManagementReportState {
  constructor(
    private transportManagementReportService: TransportManagementReportService,
    private notificationService: NotificationService,
  ) {}

  @Selector()
  static getReport(state: TransportManagementReportStateModel): TransportManagementProfileReport {
    return state.report;
  }

  @Selector()
  static getState(state: TransportManagementReportStateModel): TransportManagementReportStateModel {
    return state;
  }

  @Selector()
  static getLoaded(state: TransportManagementReportStateModel): boolean {
    return state.loaded;
  }

  @Action(TransportManagementReportLoad)
  getReport(ctx: StateContext<TransportManagementReportStateModel>): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.transportManagementReportService.getReport().pipe(
      map((report: TransportManagementProfileReport) => {
        ctx.patchState({
          report: new TransportManagementProfileReport(report),
          loaded: true,
        });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(TransportManagementReportInitialState)
  setInitialState(ctx: StateContext<TransportManagementReportStateModel>): void {
    ctx.setState(initialState);
  }
}
